module.exports = __webpack_public_path__ + "static/media/createSession.fa11d0b8.svg";